import { render, staticRenderFns } from "./DirectSaleProductSale.vue?vue&type=template&id=4f5a5a84&scoped=true"
import script from "./DirectSaleProductSale.vue?vue&type=script&lang=js"
export * from "./DirectSaleProductSale.vue?vue&type=script&lang=js"
import style0 from "./DirectSaleProductSale.vue?vue&type=style&index=0&id=4f5a5a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a5a84",
  null
  
)

export default component.exports